import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import SEO from '../../components/seo/SEO';
import PixelArtAdventureBackground from '../../components/datadventure/PixelArtAdventureBackground';
import RoadmapView from '../../components/datadventure/RoadmapView';

export default function DataAdventure() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Data Adventure"
        description="Recorré el roadmap de ingeniería de datos desde 0. Cada paso te lleva a una práctica."
        keywords="data adventure, roadmap, data engineering, SQL, Python"
        url="/datadventure"
      />
      <div className="min-h-screen relative">
        <PixelArtAdventureBackground />
        <header className="border-b border-slate-200 dark:border-slate-700 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm sticky top-0 z-10">
          <div className="max-w-4xl mx-auto px-6 py-4">
            <Button
              variant="ghost"
              onClick={() => navigate(-1)}
              className="text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Volver
            </Button>
          </div>
        </header>

        <main className="relative z-10 max-w-4xl mx-auto px-6 py-12 md:py-20">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="text-center mb-8 px-6 py-5 rounded-2xl bg-white/95 dark:bg-slate-800/95 border border-slate-200 dark:border-slate-700 shadow-lg backdrop-blur-sm"
          >
            <h1 className="text-2xl md:text-3xl font-bold text-slate-800 dark:text-white mb-2">
              ¡Bienvenido al camino de tu éxito!
            </h1>
            <p className="text-lg text-slate-700 dark:text-slate-200">
              El roadmap que estabas buscando, lo tenés acá.
            </p>
          </motion.div>
          <motion.section
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="rounded-2xl bg-white/95 dark:bg-slate-800/95 border border-slate-200 dark:border-slate-700 shadow-xl backdrop-blur-sm p-6 md:p-8"
          >
            <RoadmapView />
          </motion.section>
        </main>
      </div>
    </>
  );
}
